import React from 'react';
import ReactModal from 'react-modal';
import './Modal.css';
import closeButton from './newX.png'; 

ReactModal.setAppElement('#root'); 

const formatRegistrationLink = (link) => {
    if (!link.startsWith('http://') && !link.startsWith('https://')) {
      return 'http://' + link;
    }
    return link;
  };

const Modal = ({ isOpen, onRequestClose, classData }) => {
    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Class Details"
            className="Modal"
            overlayClassName="Overlay"
        >
            <button className="close-button" onClick={onRequestClose}>
                <img src={closeButton} alt="Close"/>
            </button>
            <h2 className="class-title">{classData['Class Title']}</h2>
            <div className="divider"></div> {/* Add this line for the divider */}
            <div className="modal-content">
                <div className="pair">
                    <div className="title">Notes</div>
                    <div className="value notes-value">{classData.Notes}</div>
                </div>
                <div className="pair">
                    <div className="title">Day/Time</div>
                    <div className="value">{classData['Day/Time']}</div>
                </div>
                <div className="pair">
                    <div className="title">Teacher</div>
                    <div className="value">{classData.Teacher}</div>
                </div>
                <div className="pair">
                    <div className="title">Start Date</div>
                    <div className="value">{classData['Start Date']}</div>
                </div>
                <div className="pair">
                    <div className="title">End Date</div>
                    <div className="value">{classData['End Date']}</div>
                </div>
                <div className="pair">
                    <div className="title">Enrollment Type</div>
                    <div className="value">{classData['Enrollment Type']}</div>
                </div>
                <div className="pair">
                    <div className="title">Registration Link</div>
                    <div className="value">
                        <button className="reg-button">
                        <a 
                            href={formatRegistrationLink(classData['Registration Link'])} 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            {classData['Register']?.label || "Register"}
                        </a>
                        </button>
                    </div>
                </div>
            </div>
        </ReactModal>
    );
};

export default Modal;
